import { Component, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { debounceTime, filter, firstValueFrom, last, of, Subject, Subscription, switchMap } from 'rxjs';
import { MedicalRecordState } from 'src/app/features/medical-record/store/medical-record.state';
import { PatientService } from 'src/app/shared/services/patient/patient-info.service';
import { Router } from '@angular/router';
import { EnumPartialRoutes } from 'src/app/shared/enums/enums';
import { PatientAPI } from 'src/app/features/medical-record/medical-record-page/pages/patient-informations/model/patient.model';
import { getAuthStateSelect } from 'src/app/core/store/auth/auth.selector';
import { MedicalRecordService } from 'src/app/features/medical-record/services/medical-record.service';
import { Alerts } from '../alerts/alert';
import { TabsStateService } from 'src/app/features/medical-record/services/tabs-state.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  subscription?: Subscription;
  backgroundOn = false;
  patientsResult = signal<PatientAPI[]>([]);
  searchingPatient: boolean = false;
  searchTerm$ = new Subject<string>();
  searchInputText: string = '';
  userInitials?: string
  loadingPatient: boolean = true;

  constructor(
    private patientService: PatientService,
    private store: Store<MedicalRecordState>,
    private router: Router,
    private medicalRecordService: MedicalRecordService,
    private alerts: Alerts,
    private tabsState: TabsStateService
  ) {
    this.searchTerm$
      .pipe(
        debounceTime(200),
        filter(x => x.length > 2),
        switchMap(st => this.isInputValueNumeric(st) ? of({ identifier: st }) : of({ name: st })))
      .subscribe( async searchObj => {
        this.searchingPatient = true
        this.loadingPatient = true;
        this.patientsResult.set([])

        try {
          const res = await  this.patientService.searchPatients(searchObj);
          if (res.status !== 'ok') {
            throw new Error(res.internalStatusCode)
          }

          const resultFiltered = res.result.filter(pat => {
            if (this.isInputValueNumeric(this.searchInputText)) {
                return true
            }
            return this.patientNameIncludesSearchTerm(pat, this.searchInputText)
          });
          this.patientsResult.set(resultFiltered.sort((a, b) => {
            const firstName = a.name[0].text.split(' ')[0];
            const secondName = b.name[0].text.split(' ')[0];
            return secondName.localeCompare(firstName)
          })

          )

        } catch (e) {
          console.error(e)
        }



        this.loadingPatient = false;
        this.searchingPatient = false;

      });
  }

  // hotfix
  patientNameIncludesSearchTerm = (pat: PatientAPI, searchTerm: string) => pat.name[0].text.toLowerCase().includes(searchTerm.toLowerCase())

  parseNameToInitials(fullName: string) {
    const names = fullName.split(' ');
    const firstName = names[0];
    const lastName = names.pop() ?? ''
    return firstName[0] + lastName[0]
  }

  ngOnInit(): void {
    this.subscription = this.store.select(getAuthStateSelect).subscribe((user) => {
      if (user.isLogged && user.user) {
        this.userInitials = this.parseNameToInitials(user.user.name);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  async selecPatient(patient: PatientAPI | null, isChangingPage?: boolean) {

    const isOpen =  await firstValueFrom(this.medicalRecordService.isMedicalRecordOpen)
    if (isOpen) {
      this.alerts.alertWithOneButton('error', 'Paciente em Atendimento', 'Para sair do prontuário aberto você precisa "Finalizar o Atendimento" ou "Descartar o Atendimento".', 'Entendido');
      return
    }
    if (!isChangingPage && patient) {
      this.selectPatient(patient)
      return
    }
    this.navigateToSchedule()

  }

  selectPatient(patient: PatientAPI) {

    this.patientService.setSelectedPatientById(patient.id)
    this.patientsResult.set([]);
    this.searchTerm$.next('');
    this.backgroundOn = false;
    this.searchInputText = '';
    this.tabsState.changeTab("diagnóstico")

    if (this.router.url == '/schedule/day-view') {
      this.router.navigate([EnumPartialRoutes.MEDICAL_RECORD]);
    }
  }

  navigateToSchedule() {
    this.patientService.setSelectedPatientById(null)
    this.router.navigate([EnumPartialRoutes.SCHEDULE_DAY_VIEW]);
  }

  private isInputValueNumeric = (x: string): boolean => {
    const numericRegex: RegExp = /^[0-9]+$/;
    return numericRegex.test(x);
  }

  onSearchTermChange(term: string): void {
    this.searchTerm$.next(term);
    this.searchInputText = term
    // if (term.length < 3) {
    //   this.patientsResult = [];
    // }
  }

  onInputFocus() {
    this.backgroundOn = true
  }


  onBlur() {
    if (this.patientsResult().length === 0) {
      this.backgroundOn = false
    }
  }

  resetSearch() {
    this.patientsResult.set([])
    this.backgroundOn = false;
    this.searchTerm$.next('')
    this.searchInputText = ''
  }






}
